import { render, staticRenderFns } from "./cert.vue?vue&type=template&id=3179460a&scoped=true&"
import script from "./cert.vue?vue&type=script&lang=js&"
export * from "./cert.vue?vue&type=script&lang=js&"
import style0 from "./cert.vue?vue&type=style&index=0&id=3179460a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179460a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CarouselBase64: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/carousel/base64.vue').default})
